// extracted by mini-css-extract-plugin
module.exports = {"contentSpace":"rate_contentSpace__2vizT"};